import { Grid, Input, Slider, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { convertVolume, revertVolume } from "../helpers/convertVolume";
import { getWaterfloodForecastGW } from "../reducers/groupWellSlice";
import { selectOptions } from "../reducers/optionsSlice";
import { getWaterfloodForecast } from "../reducers/wellSlice";

const MONTH_LENGTH = 30.436875;

const useStyles = makeStyles(theme => ({
  setting: {
    width: '100%',
    margin: '10px 0',
    padding: 10,
    backgroundColor: 'transparent',
  },
  input: {
    width: 70,
  },
  details: {
    margin: 0,
    padding: 0
  }
}));

export function WaterfloodSetting({ param, well, darkMode, forecastListTab }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const options = useSelector(selectOptions);

  return (
    <div className={classes.setting}>
      <Typography id='input-slider' gutterBottom noWrap>
        {getLabelName(param)} <span style={{fontSize: 12}}>{getUnits(param, options?.units)}</span>
      </Typography>

      <Grid container spacing={2} alignItems="center">
        <Grid item xs style={{margin: '0 10px'}}>
          <Slider
            value={getValue(well?.params?.waterflood?.[param], param)}
            onChange={(e, newValue) => handleValueChange(newValue, param)}
            min={getMinMaxStep(param)[0]}
            max={getMinMaxStep(param)[1]}
            step={getMinMaxStep(param)[2]}
            valueLabelDisplay="auto"
            style={{color: (darkMode ? '#fff' : '#0758B7')}}
          />
        </Grid>
        <Grid item>
          <Input
            className={classes.input}
            value={getValue(well?.params?.waterflood?.[param], param)}
            margin="dense"
            onChange={(e) => handleValueChange(e.target.value, param)}
            inputProps={{
              min: getMinMaxStep(param)[0],
              max: getMinMaxStep(param)[1],
              step: getMinMaxStep(param)[2],
              type: 'number',
            }}
          />
        </Grid>
      </Grid>
    </div>
  );

  function getValue(value, param) {
    let newValue = Number(value);
    if (param === 'di' || param === 'qi') {
      newValue = newValue * 100;
    } else if (param === 'maxFluidRate') {
      newValue = convertVolume((newValue > 0 ? newValue : 1), options.units, 'oil') / MONTH_LENGTH;
    } else if (param === 'cutoff') {
      newValue = convertVolume((newValue > 0 ? newValue : 1), options.units, 'oil') / MONTH_LENGTH;
    };
    newValue = roundNumber(newValue, param) || 0;

    return newValue;
  };

  function handleValueChange(value, param) {
    try {
      let newValue = Number(value);

      if (param === 'di') { // di min is 0.4%
        newValue = Math.max(newValue, 0.4) / 100;
      } else if (param === 'qi') { // qi max is 100%
        newValue = Math.min(newValue, 100) / 100;
      } else if (param === 'b') {
        newValue = Math.max(newValue, 0.01);
      } else if (param === 'maxFluidRate') {
        newValue = revertVolume(newValue, options.units, 'oil') * MONTH_LENGTH;
      } else if (param === 'cutoff') {
        newValue = revertVolume(newValue, options.units, 'oil') * MONTH_LENGTH;
      };
      if (forecastListTab === 0) {
        !isNaN(newValue) && dispatch(getWaterfloodForecast({...well, params: {...well.params, waterflood: {...well.params.waterflood, [param]: roundNumber(newValue, param)}}}));
      } else if (forecastListTab === 2) {
        !isNaN(newValue) && dispatch(getWaterfloodForecastGW({...well, params: {...well.params, waterflood: {...well.params.waterflood, [param]: roundNumber(newValue, param)}}}));
      };

    } catch (error) {
      console.log(error);
    };
  };

  function getMinMaxStep(param) {
    switch(param) {
      case 'ti':
        return [1, 360, 1];
      case 'qi':
        return [0.1, 100, 0.1];
      case 'di':
        return [0, 100, 0.01];
      case 'b':
        return [0.01, 2, 0.01];
      case 'maxFluidRate':
        return options.units === 'metric' ? [1, 200, 0.1] : [1, 1000, 0.1];
      case 'cutoff':
        return options.units === 'metric' ? [0.1, 50, 0.1] : [0.1, 500, 0.1];
      default:
        return;
    };
  };

  function getLabelName(param) {
    switch(param) {
      case 'ti':
        return 'Forecast Start Month'
      case 'qi':
        return 'Initial Oil Cut'
      case 'di':
        return 'Initial Decline Rate'
      case 'b':
        return 'Hyperbolic Constant';
      case 'maxFluidRate':
        return 'Maximum Fluid Rate';
      case 'cutoff':
        return 'Forecast Cutoff';
      default:
        return;
    };
  };

  function getUnits(param, units) {
    switch(param) {
      case 'qi':
        return '%'
      case 'di':
        return units === 'metric' ? '%/m3' : '%/bbl'
      case 'maxFluidRate':
        return units === 'metric' ? 'm3/day' :'bbl/day';
      case 'cutoff':
        return units === 'metric' ? 'm3/day' :'bbl/day';
      default:
        return '';
    };
  };

  function roundNumber(value, param) {
    // return Math.round((value * 100 + Number.EPSILON) * 100) / 100;
    if (param === 'qi' || param === 'di') {
      return Number(value.toFixed(4));
    };
    return Number(value.toFixed(2));
  };
  
};